import { render, staticRenderFns } from "./EditConfigurationPageLinkRouter.vue?vue&type=template&id=15361a45&"
import script from "./EditConfigurationPageLinkRouter.vue?vue&type=script&lang=js&"
export * from "./EditConfigurationPageLinkRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports